module.exports = "/assets/rwp-main-hand-mobile.png?WQNQsI7";